export default {
  state: {
    recoverPasswordMenu: {
      isVisible: false
    },
    recoverPasswordData: {
      NMLOGINCONS: '',
      userName: ''
    }
  },
  mutations: {
    setRecoverPasswordData (state, data) {
      state.recoverPasswordData = data
    },
    setRecoverPasswordMenuVisibility (state) {
      state.recoverPasswordMenu.isVisible = !state.recoverPasswordMenu.isVisible
    }
  },
  actions: {
    setRecoverPasswordData ({ commit }, data) {
      commit('setRecoverPasswordData', data)
    },
    changeRecoverPasswordMenuVisibility ({ commit }) {
      commit('setRecoverPasswordMenuVisibility')
    }
  },
  getters: {
    getRecoverPasswordData: (state) => state.recoverPasswordData,
    recoverPasswordMenu: (state) => state.recoverPasswordMenu
  }
}
